import { DatePipe } from '@angular/common';
import { Component, ElementRef, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import { formatDate } from 'devextreme/localization';
import * as _ from 'lodash';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { TourService } from 'ngx-tour-md-menu';
import { ISubscription } from "rxjs/Subscription";
import { environment } from '../../shared/config/app-config';
import { CallService, FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { User } from '../../shared/models';
//import { fchown } from 'fs';
//import {HeaderComponent} from '../../shared/index'

@Component({
  selector: 'app-patqualifi',
  templateUrl: './patqualifi.component.html',
  styleUrls: ['./patqualifi.component.css'],
})
export class PatqualifiComponent extends FormSessionCanDeactivate {

  filterValue: any;
  format: boolean;
  showinvaild2: boolean;
  showloader: boolean = false;
  maxpdate: boolean = false;
  enableenroll: boolean;
  dataindex: any;
  isedit: number = 0;
  dosdate: any;
  editable: any = {
    lastName: false,
    firstName: false,
    bundlePayorName: false,
    opmax: false,
    opbalance: false,
    patientResponsibility: false,
    surgeonName: false,
    serviceline: false,
    preferredFacility: false,
    status: false,
    qstatus: false,
    notesTitle: false
  };
  @ViewChild('scrollMe')
  private myScrollContainer: ElementRef;
  fcneditable: any;
  cneditable: any;
  editorOptions: any;
  disqu: boolean;
  enroll: boolean;
  templatedel: TemplateRef<any>
  enrolled: TemplateRef<any>;
  index: number;
  qualifi: any;
  tooltipnew: any;
  reason: any = [];
  editpatient: any = [];
  patdata: any;
  i: number = 0;
  dosvalue = ''
  public bobMaxDate = new Date();
  public dosMaxDate = new Date();
  dos: string;
  stage: any = "";
  status: any = "";
  public msg: any = {
    title: '',
    comment: ''
  };
  selectedObj: any = "Default";
  patdisqualifi: any = {};
  popupVisible: boolean;
  dtOptions: any = {};
  selpat: string = 'Reassign To';
  multiple: string = '';
  reasontype: any;
  selCare: string;
  lengthcn: any;
  todate: Date = new Date()
  careList: any;
  select: boolean;
  dataSource: ArrayStore;
  tempother: boolean;
  temppat: any;
  surgicalstage: ({ text: string; value: (string | number)[]; } | { text: string; value: (string | number)[][]; })[];
  group: any;
  surdis: boolean;
  disabled: boolean;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  getTotalPageCount() {
    if (this.dataGrid)
      return this.userService.translateText('hospital_portal.mytodos.paginationsub1.label') + this.dataGrid.instance.totalCount() + this.userService.translateText('hospital_portal.mytodos.paginationsub2.label');
    return this.userService.translateText('hospital_portal.mytodos.pagination.label');
  }
  enablepatient: boolean;
  emp: any;
  showinvaild1: boolean;
  showinvaild: boolean;
  traccount: any;
  selectedItemKeys: any[] = [];
  public objs: any = {

  };
  dropdownPSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  dropdownSSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  surg: any;
  prod: any;
  dtdownloadOptions: any = {};
  hosp: any;
  public notesenrollpat: ''
  down_care: {};
  downloadcare: boolean = false
  tempvar: boolean;
  timealert: any = environment.timelimit;
  tractionlist: any;
  hospid: any;
  suglist: any;
  serviceline: any;
  modalDataArray: any = [];
  public data: Object;
  public modalRef: BsModalRef;
  modaldata: any;
  track: any;
  tempmsg: any;
  public getdos: any;
  public name: any;
  public temp_var: boolean = false;
  public dateformat = environment.dateFormat;
  public dateform = environment.dateForm;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  date: any = {
    'dos': "04/13/2018"
  }
  @ViewChild('videoPlayer') videoplayer: any;
  notes: any;
  notesmsg: any;
  enrolllist: any;
  Qnote: any;
  pbundleid: any;
  result: boolean;
  valid: boolean = false;
  enrolledpat: any;
  ccnchecked: boolean = false;
  qualificationcount: number;
  patdetail: any;
  disresult: any;
  // @HostListener('window:beforeunload')
  // canDeactivate(): Observable<boolean> | boolean {
  //   return !this.dataGrid.instance.hasEditData();
  // }
  public patient: any;
  public patname: any;
  public download_care: any = environment.downloadcare;
  public apiurl: any = environment.api_url;
  public caremap: any = environment.practiceid;
  public str: any = {}
  empdetails: any = {}
  public currentUser: User;
  fcnempty: boolean = false
  detail: any = {};
  emp1: any;
  downloaddata: any = {}
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  newreq: boolean = true;
  Download: boolean = false;

  hospital: any[];
  qualification: any[] = [];
  subscription: ISubscription;
  popout: boolean = false;
  isccn: boolean = false;
  isfcn: boolean = false;
  facility: any;
  empccn: any;
  empfcn: any;
  type: any = 'Default';
  fullname: any;
  time = formatDate(new Date(), "MM/dd/yyyy h:mm a");
  ccnlist: any = {};
  checked: boolean = false;
  listname: any;
  ccnstatus: any;
  visible: boolean;
  public imageURL: string = environment.cloudeImageURL;
  cities: any[] = [{
    "qualificationId": 1,
    "title": "Pending Medical Qualification",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.pending_qualif.option'),
    "stageName": 'Verify medical qualification'
  }, {
    "qualificationId": 2,
    "title": "Medically qualified",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.medically_qualified.label'),
    "stageName": 'Verify medical qualification'
  }, {
    "qualificationId": 3,
    "title": "Not Medicaly Qualify",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.not_medicaly_qualify.label'),
    "stageName": 'Verify medical qualification'
  }, {
    "qualificationId": 4,
    "title": "Pending",
    "titleDisplayName": this.userService.translateText('hospital_portal.mytodos.pending.label'),
    "stageName": 'Verify Financial Qualification'
  }, {
    "qualificationId": 5,
    "title": "Benefits checked",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.benefits_checked.label'),
    "stageName": "Verify Financial Qualification"
  }, {
    "qualificationId": 18,
    "title": "Not Financial Qualify",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.not_financial_qualify.label'),
    "stageName": "Verify Financial Qualification"
  }, {
    "qualificationId": 6,
    "title": "Pending",
    "titleDisplayName": this.userService.translateText('hospital_portal.mytodos.pending.label'),
    "stageName": "Call to discuss program"
  }, {
    "qualificationId": 7,
    "title": "Interested",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.interested.label'),
    "stageName": "Call to discuss program"
  }, {
    "qualificationId": 8,
    "title": "Not interested",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.not_interested.label'),
    "stageName": "Call to discuss program"
  }, {
    "qualificationId": 9,
    "title": "Pending collection",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.pending_collection.label'),
    "stageName": "Schedule payment collection"
  }, {
    "qualificationId": 10,
    "title": "Partially paid",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.partially_paid.label'),
    "stageName": "Schedule payment collection"
  }, {
    "qualificationId": 11,
    "title": "Paid in full",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.paid_in_full.label'),
    "stageName": "Schedule payment collection"
  }, {
    "qualificationId": 12,
    "title": "Defaulted",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.defaulted.label'),
    "stageName": "Schedule payment collection"
  }, {
    "qualificationId": 13,
    "title": "Pending",
    "titleDisplayName": this.userService.translateText('hospital_portal.mytodos.pending.label'),
    "stageName": "Ready to schedule surgery"
  }, {
    "qualificationId": 14,
    "title": "Enrolled",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.enrolled.label'),
    "stageName": "Ready to schedule surgery"
  }, {
    "qualificationId": 15,
    "title": "Partially Paid",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.partially_paid.label'),
    "stageName": "Follow-up with Payment Plan"
  }, {
    "qualificationId": 16,
    "title": "Paid in Full",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.paid_in_full.label'),
    "stageName": "Follow-up with Payment Plan"
  }, {
    "qualificationId": 17,
    "title": "Defaulted",
    "titleDisplayName": this.userService.translateText('hospital_portal.qualification_lst.defaulted.label'),
    "stageName": "Follow-up with Payment Plan"
  }];
  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public modalService: BsModalService,
    public router: Router,
    private callService: CallService,
    public patientservice: PatientService,
    public userService: UserService,
    public tourService: TourService,
    private dialog: MatDialog,
    private localeService: BsLocaleService,
    private DatePipe: DatePipe,
  ) {
    super();
    this.qualification = [{
      "Name": "Pending Medical Qualification",
      "displayName": this.userService.translateText('hospital_portal.qualification_lst.pending_qualif.option')
    }, {
      "Name": "Not Qualified",
      "displayName": this.userService.translateText('hospital_portal.qualification_lst.not_qualif.option')
    }, {
      "Name": "Pending",
      "displayName": this.userService.translateText('hospital_portal.mytodos.pending.label')
    }, {
      "Name": "Enrolled",
      "displayName": this.userService.translateText('hospital_portal.qualification_lst.enrolled.label')
    }, {
      "Name": "Medically qualified",
      "displayName": this.userService.translateText('hospital_portal.qualification_lst.medically_qualified.label')
    }];
    this.filterValue = []
    if (localStorage.getItem("patQualiFilter")) {
      this.filterValue = JSON.parse(atob(localStorage.getItem("patQualiFilter")))
    }



    this.editorOptions = {
      format: "$ #,##0.##",
      precision: 2

    }
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        this.currentUser.status = false;
        if (this.currentUser.item) {
          if (this.currentUser.item.dateFormat)
            if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
              this.dateformat = environment.dateFormat;
              this.dateform = environment.dateForm;
            } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
              this.dateformat = 'DD/MM/YYYY'
              this.dateform = 'dd/MM/yyyy'
            }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      }
    )


    this.subscription = callService.pqtcomponentMethodCalled$.subscribe(
      () => {
        this.temp_var = false;
        this.ngOnInit();
      }
    );
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    this.getqualifi = this.getqualifi.bind(this);
    this.getstage = this.getstage.bind(this);
    this.qualificationHeaderFilter = this.qualificationHeaderFilter.bind(this)
  }


  ngOnDestroy() {
    // alert("Destroy Calling Here");
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.popout) {
      this.modalRef.hide();
    }
    /* if (this.popupVisible == false) {
      let self = this;
      let ccresult = this.dialog.open(ConfirmtempComponent, { hasBackdrop: true, disableClose: true });
      ccresult.afterClosed().subscribe(result => {
      ccresult.close();
      if (result == 'yes') {
      } else {
      }
      });
    } */
  }


  // ngOnChanges(){
  //   this.ngOnInit();
  // }
  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  ngOnInit() {
    this.scrollToBottom();
    this.disabled = false;
    // this.subscription.unsubscribe();
    this.route.params.subscribe((params: Params) => {
      ////console.log(params);
      // this will be called every time route changes
      // so you can perform your functionality here

    });
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )
    this.patient = [];

    if (this.currentUser.item.userGroupId) {
      this.patientservice
        .getStageTabQualificationDetails(this.currentUser.item.userGroupId)
        .subscribe(
          data => {
            this.cities = data
          }
        );
    }
    this.getqualificationcount()




    if (this.currentUser.item.userrole == 'Care Navigator' || this.currentUser.item.userrole == 'Care Coordinator' || this.currentUser.item.userrole == 'Surgeon' || this.currentUser.item.userrole == 'Commercial Care Navigator' || this.currentUser.item.userrole == 'Financial Care Navigator') {
      if (this.currentUser.item.userrole == 'Surgeon') {
        this.surdis = true
        this.disabled = false;
      }
    }
    else {
      this.disabled = true
    }

    if (this.currentUser.item.userGroupId == 27) {
      this.isccn = true
      this.currentUser.item.userGroupId = 27
    }
    else if (this.currentUser.item.userGroupId == 28) {
      this.isfcn = true
      this.currentUser.item.userGroupId = 28
    }
    if (this.currentUser.item.userGroupId)
      this.qstage();
    this.reasonstage()
    this.qualify(this.type);
    this.fullname = this.currentUser.item.firstName + " " + this.currentUser.item.lastName
    if (this.currentUser.item.userrole == 'Commercial Care Navigator') {
      this.isccn = true
    }
    else if (this.currentUser.item.userrole == 'Financial Care Navigator') {
      this.isfcn = true
    }
  }
  newfun(e) {

    this.tooltipnew = e;
    if (this.tooltipnew.imagePath.search("default_") != -1)
      this.tooltipnew.deaultimg = true
    else
      this.tooltipnew.deaultimg = false
  }

  qstage() {
    this.patientservice
      .getStageQualificationDetails(this.currentUser.item.userGroupId)
      .subscribe(
        data => {
          this.qualification = data;
          if(data && data.length > 0 && data[0]['qualificationDataDisplayName'].length > 0) {
            this.qualification.map((ele,index) => {
              ele.qualificationData.map((element, subIndex) => {
                element['titleDisplayName'] = data[index]['qualificationDataDisplayName'].find(el=> el.qualificationId == element.qualificationId)['title'] || ''
              });
            })
          }

        }

      );

  }
  setStateValue(rowData: any, value: any): void {
    rowData.qualificationId = null;
    (<any>this).defaultSetCellValue(rowData, value);
  }
  setStatusValue(rowData: any, value: any): void {
    if (value == 14) {
      // this.modalRef = self.modalService.show(this.enrolled, { class: 'modal-md', backdrop: 'static' })
      this.enroll = true;
    } else if (value == 3 || value == 8 || value == 12 || value == 17) {
      if (this.type != 'Disqualified')
        this.disqu = true;
    }
  }
  getqualifi(options) {
    return {
      store: this.cities,
      filter: options.data ? ["stageName", "=", options.data.stageName] : null

    }

    /* if (this.qualification && patient) {
      let index = _.findIndex(this.qualification, (o: any): any => {
        return o.stageId == patient.stageId
      })
     
        return this.qualification[index].qualificationData
     
        
      
    } */

  }
  getstage(options) {
    var getstagevalue = [];
    for (var i = 0; i < this.qualification.length; i++) {
      if (this.qualification[i].stageId % 2 != 0 && this.isccn && this.type != 'All')
        getstagevalue.push(this.qualification[i])
      if (this.qualification[i].stageId % 2 == 0 && this.isfcn && this.type != 'All')
        getstagevalue.push(this.qualification[i])
      if (this.type == 'All')
        getstagevalue.push(this.qualification[i])
    }
    return {
      store: getstagevalue
    }

  }
  qualificationHeaderFilter(data) {
    data.dataSource.postProcess = (results) => {
      results.shift()
      results = _.uniqBy(results, (e: any): any => {
        return e.title.toLowerCase()
      })
      return results;
    };
  }

  onEditorPreparing(enrolled: TemplateRef<any>, templatedel: TemplateRef<any>, e) {
    let self = this;
    if (e.parentType == "dataRow") {
      if (this.isfcn)
        e.editorOptions.disabled = (e.row.data.stageId == 1 || e.row.data.stageId == 3 || e.row.data.stageId == 5) || (e.row.data.archived && self.type != 'PreferedFacility');
      else
        e.editorOptions.disabled = (e.row.data.stageId == 2 || e.row.data.stageId == 4 || e.row.data.stageId == 6) || e.row.data.archived;
      e.editorOptions.onValueChanged = function (args) {
        if (args.value >= 0 && args.value != '') {
          e.setValue(args.value);
          if (self.isedit == 0 || self.dataindex != e.row.dataIndex) {
            self.dataindex = e.row.dataIndex
            self.isedit++;
          }
        } else {
          self.toastr.error(this.userService.translateText('hospital_portal.disp_messages.responsibility_positive.error'))
        }
      }
    }
    if (e.dataField == "stageId") {
      if (e.row.data.stageId > 5) {
        e.editorOptions.disabled = true
      }
      else {
        e.editorOptions.onValueChanged = function (args) {
          if (args.value) {
            e.setValue(args.value);
            if (self.isedit == 0 || self.dataindex != e.row.dataIndex) {
              self.dataindex = e.row.dataIndex
              self.isedit++;
            }

          }
          let index = _.findIndex(self.qualification, (o: any): any => {
            return o.stageId == args.value
          })
          let index1 = _.findIndex(self.patient, (o: any): any => {
            return o.bundlePatientId == e.row.data.bundlePatientId
          })
          if (index != -1 && index1 != -1) {
            self.patient[index1].stageName = self.qualification[index].title
          }
          if (args.value > 5) {
            self.toastr.error(this.userService.translateText('hospital_portal.disp_messages.movement_stage_possible.error'))
            let index = _.findIndex(self.qualification, (o: any): any => {
              return o.stageId == args.previousValue
            })
            self.dataGrid.instance.cancelEditData();
            self.isedit--
            let index1 = _.findIndex(self.patient, (o: any): any => {
              return o.bundlePatientId == e.row.data.bundlePatientId
            })
            if (index != -1 && index1 != -1) {
              self.patient[index1].stageName = self.qualification[index].title
            }
          }
        }
      }
    }
    if (e.dataField == "qualificationId") {
      let modalService = this.modalService
      ////console.log(e.row.key,"value")
      this.getdos = e.row.key.dos
      this.patdetail = e.row.key
      this.patdata = e.row.data
      this.ccnstatus = this.patdata.preferredFacility
      this.patdisqualifi.stageId = e.row.data.stageId
      e.editorOptions.onValueChanged = function (args) {
        if (args.value) {
          e.setValue(args.value);
          if (self.isedit == 0 || self.dataindex != e.row.dataIndex) {
            self.dataindex = e.row.dataIndex
            self.isedit++;
          }
        }
        let index = _.findIndex(self.cities, (o: any): any => {
          return o.qualificationId == args.value
        })
        let index1 = _.findIndex(self.patient, (o: any): any => {
          return o.bundlePatientId == e.row.data.bundlePatientId
        })
        if (index != -1 && index1 != -1) {
          self.patient[index1].qualificationName = self.cities[index].title
        }
        // Implement your logic here
        if (args.value == 14) {
          self.fcn(self.patdata.bundlePatientId);
          self.dosdate = new Date(self.patdata.dos)
          if (self.dosdate) {
            let currentdate = new Date()
            if (self.dosdate < currentdate) {
              self.dosMaxDate = new Date(self.dosdate)
            } else {
              self.dosMaxDate = new Date()
            }
          } else {
            self.dosMaxDate = new Date()
          }
          // self.modalRef = modalService.show(enrolled, { class: 'modal-lg', backdrop: 'static' })
          self.router.navigate([`/care/patsummaryinfo/${self.patdata.bundlePatientId}/${e.row.data.stageId}/${args.value}`])
          self.dataGrid.instance.cancelEditData()

        } else if (args.value == 3 || args.value == 8 || args.value == 12 || args.value == 17 || args.value == 18) {
          self.patdisqualifi.qualificationId = args.value
          self.patdisqualifi.reasonId = ""
          self.modalRef = modalService.show(templatedel, { class: 'modal-lg', backdrop: 'static' })

        } else if (args.value == 5 && !self.patdata.facilityPRStatus) {
          self.toastr.error(this.userService.translateText('hospital_portal.qualification_lst.preferred_facility_amt.error'))
          let index = _.findIndex(self.cities, (o: any): any => {
            return o.qualificationId == args.previousValue
          })
          self.dataGrid.instance.cancelEditData();
          self.isedit--
          let index1 = _.findIndex(self.patient, (o: any): any => {
            return o.bundlePatientId == e.row.data.bundlePatientId
          })
          if (index != -1 && index1 != -1) {
            self.patient[index1].qualificationName = self.cities[index].title
          }
        }
        /* else if (args.value == 7 && !self.patdata.preferredFacility) {
          self.toastr.error("Preferred Facility should not empty")
          let index = _.findIndex(self.cities, (o: any): any => {
            return o.qualificationId == args.previousValue
          })
          self.dataGrid.instance.cancelEditData();
          self.isedit--
          let index1 = _.findIndex(self.patient, (o: any): any => {
            return o.bundlePatientId == e.row.data.bundlePatientId
          })
          if (index != -1 && index1 != -1) {
            self.patient[index1].qualificationName = self.cities[index].title
          }
        } */
        /* else if ((args.value == 10 || args.value == 11) && self.patdetail.opbalance == '' && self.patdetail.opmax == '' && self.patdetail.patientResponsibility == '') {
          self.toastr.error("Out of pocket and patient responsibility should not be empty")
          let index = _.findIndex(self.cities, (o: any): any => {
            return o.qualificationId == args.previousValue
          })
          self.isedit--
          self.dataGrid.instance.cancelEditData();
          let index1 = _.findIndex(self.patient, (o: any): any => {
            return o.bundlePatientId == e.row.data.bundlePatientId
          })
          if (index != -1 && index1 != -1) {
            self.patient[index1].qualificationName = self.cities[index].title
          }
        } */
        // Updates the cell value
      }
    }
    this.movable()

  }
  getqualifibystage(id) {
    let self = this
    let index = _.findIndex(self.cities, (o: any): any => {
      return o.qualificationId == id
    })
    if (index != -1)
      return self.cities[index].titleDisplayName
    else
      return ''
  }
  onCellClick(args) {

    let self = this;
    self.i = self.i + 1;
    args.key.loginUaId = this.currentUser.item.userAccountId
    self.editpatient.push(args.key)
    ////console.log(self.editpatient)
    if (self.isedit == self.i) {
      this.patientservice
        .postBundlePatientDetailsid(self.editpatient)
        .subscribe(
          data => {
            if (data) {
              this.toastr.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('updateBundlePatients', 0).subscribe(data => { })
              self.isedit = 0
              self.i = 0
              self.editpatient = []
              this.ngOnInit()
              this.headerqualificationcount()
            } else {
              this.toastr.error(this.userService.translateText('hospital_portal.disp_messages.patient_not_saved.error'), '', {
                timeOut: this.timealert
              })
              self.editpatient = []
              this.qualify(this.type)
              this.headerqualificationcount()
              self.isedit = 0
              self.i = 0
            }
          }
        );
    }

  }
  savePatient() {
    alert("Hi")

  }

  getTitle() {
    return this.userService.translateText('hospital_portal.qualification_lst.patient_qualification_list.label')
  }

  clear() {
    this.msg.title = ''
    this.msg.comment = ''
  }
  openModel(confirm: TemplateRef<any>, emp) {
    this.patdetail = emp
    let self = this;
    this.modalRef = self.modalService.show(confirm, { class: 'modal-lg', backdrop: 'static' })
    this.emp = emp
    this.msg.title = this.emp.notesTitle;
    this.msg.comment = this.emp.notesComments;
    ////console.log(this.emp.bundlePatientId)
    this.enablepatient = true
    self.popout = true
    this.Noteslist()
    this.movable()
  }
  openCCN(ccn: TemplateRef<any>, emp) {
    let self = this;
    this.patdetail = emp
    this.modalRef = self.modalService.show(ccn, { class: 'modal-lg', backdrop: 'static' })
    this.empfcn = emp
    ////console.log(this.empfcn)
    this.fcn(this.empfcn.bundlePatientId);
    //this.ccnchecked(this.empfcn.preferredFacility)
    this.ccnstatus = this.empfcn.preferredFacility
    this.visible = true
    this.movable()
  }


  disqualifipat(templatedel: TemplateRef<any>, patdata) {

    this.patdetail = patdata
    this.patdata = patdata
    this.patdisqualifi.stageId = patdata.stageId
    this.patdisqualifi.reasonId = ''
    this.changestage(patdata.stageId)
    this.modalRef = this.modalService.show(templatedel, { class: 'modal-lg', backdrop: "static" });
    this.movable()

  }
  onCellPrepared(e) {
    if (e.rowType == "data" && e.column.dataField == "qualificationId" && !e.data.archived) {
      if ((e.data.stageId == 2 || e.data.stageId == 4 || e.data.stageId == 6) && this.isfcn) {
        e.column.allowEditing = true
      } else if ((e.data.stageId == 1 || e.data.stageId == 3 || e.data.stageId == 5) && this.isccn) {
        ////console.log(e.data.stageName)
        e.column.allowEditing = true
      } else {
        e.column.allowEditing = false
      }
    }
    else if (e.rowType == "data" && (e.column.dataField == "opbalance" || e.column.dataField == "opmax" || e.column.dataField == "patientResponsibility") && !e.row.data.archived) {
      if ((e.data.stageId == 2 || e.data.stageId == 4 || e.data.stageId == 6) && this.isfcn) {
        e.column.allowEditing = true
      } else {
        e.column.allowEditing = false
      }
    } else {
      e.column.allowEditing = false
    }
  }
  selectpreferred(type) {
    this.type = type
    this.selectedObj = this.type
    this.qualify(this.type)
  }
  openFCN(fcn: TemplateRef<any>, emp) {
    this.patdetail = emp
    let self = this;
    this.modalRef = self.modalService.show(fcn, { class: 'modal-lg', backdrop: 'static' })
    this.empfcn = emp
    ////console.log(this.empfcn)
    this.movable()
    this.fcn(this.empfcn.bundlePatientId);

  }

  onEditorFCN(e) {
    ////console.log(e.value)

    let self = this
    if (e.dataField == 'patientResponsibility') {
      e.editorOptions.onValueChanged = function (args) {
        if (args.value >= 0 && args.value != '') {
          self.fcnempty = false
          var n = parseFloat(args.value).toFixed(2);
          e.setValue(n.toString());
        }
        else {
          self.toastr.error(this.userService.translateText('hospital_portal.disp_messages.patient_resp_positive.error'))
          self.fcnempty = true
        }
      }
    }

  }

  getresult() {
    this.result = true
  }
  refreshAllGrids() {
    this.dataGrid.instance.clearFilter();
  }
  close() {
    this.popout = false
    if (this.patdisqualifi) {
      this.patdisqualifi = {}
      if (this.dataGrid.instance.hasEditData()) {
        this.dataGrid.instance.cancelEditData()
      }
    }
    if (this.patdata) {
      this.patdata = ''
    }
    if (this.fcnempty) {
      this.fcnempty = false
    }
    this.notesenrollpat = ""
    this.modalRef.hide()
  }
  fcn(bundleid) {
    this.patientservice
      .getPatientFacility(bundleid, this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          this.facility = data;
          for (var i = 0; i < this.facility.length; i++) {
            if (!this.facility[i].patientResponsibility) {
              this.facility[i].patientResponsibility = '0'
            }
          }
          // this.facility.forEach(data=>{data.createdBy=this.currentUser.item.userAccountId }) // will use in future
        }

      );

  }
  selectionChanged(data: any) {
    ////console.log(data.data.hospitalId)
    ////console.log(data.data, data.value)

    // let updateItem = this.facility.find(data.data.facilityId, data.value);
    // this.facility.push(data)
    //var res = this.facility.map(obj => data.data.find(o => o.hospitalId === obj.hospitalId) || obj);



    this.getvalid(data)
  }
  faciltypacks() {
    let self = this
    this.modalRef.hide()
    ////console.log(this.facility)
    this.patientservice
      .savefacilitypack(this.currentUser.item.userAccountId, this.facility)
      .subscribe(
        data => {
          if (data.Status == 'Success') {
            this.toastr.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
              timeOut: this.timealert
            })
            this.userService.logAudit('saveBundleFacilityList', this.facility[0].bundlePatientId).subscribe(data => { })
            let index1 = _.findIndex(self.patient, (o: any): any => {
              return o.bundlePatientId == this.facility[0].bundlePatientId
            })
            if (index1 != -1) {
              self.patient[index1].facilityPRStatus = true
            }
          }
        }
      );
  }
  getvalid(facility) {

    //var filterlist = this.facility.filter(item => item.name == e.target.id)
    ////console.log(facility)

    let index = _.findIndex(this.facility, (o: any): any => {
      return (o.patientResponsibility == '' || o.patientResponsibility == null || o.patientResponsibility == undefined)
    })

    if (index == -1) {
      return false
    } else {
      return true
    }
  }
  imges = (args: any) => {
    return {
      html: "<div class='state-tooltip'><img alt='' src='" + this.apiurl +
        args.imagePath + "' </div>"
    };
  }
  qualify(e) {
    this.temp_var = false;
    this.patient = []
    ////console.log(e)
    this.type = e;
    ////console.log(this.type)
    this.patientservice
      .getBundlePatientDetails(this.currentUser.item.userAccountId, this.type)
      .subscribe(
        data => {
          this.temp_var = true;
          this.patient = data;
          for (var i = 0; i < this.patient.length; i++) {
            if (this.patient[i].fracture) {
              this.patient[i].fract = 'Fracture'
            }
            if (!this.patient[i].patientResponsibility) {
              this.patient[i].patientResponsibility = '0'
            }
            if (this.type == 'Paid in full') {
              let index = _.findIndex(this.cities, (o: any): any => {
                return o.qualificationId == 16
              })
              this.cities[index].stageName = 'Enrolled'

              if (this.patient[i].qualificationId == 16) {
                this.patient[i].stageName = 'Enrolled'
              }
            }
            else {
              let index = _.findIndex(this.cities, (o: any): any => {
                return o.qualificationId == 16
              })
              this.cities[index].stageName = 'Follow-up with Payment Plan'
            }
          }
          this.dataSource = new ArrayStore({
            key: "bundlePatientId",
            data: this.patient
          });
          if (this.dataGrid) {
            if (this.dataGrid.instance.hasEditData())
              this.dataGrid.instance.cancelEditData()
            this.dataGrid.instance.clearFilter();
            this.dataGrid.instance.refresh();
          }
        }

      );

  }

  getqualificationcount() {
    this.patientservice.getcountqual('PreferedFacility', this.currentUser.item.userAccountId, this.currentUser.item.selectCNUserId).subscribe(
      data => {
        if (data)
          this.qualificationcount = parseInt(data.Count)
      }
    )
  }

  getedit(event) {
    if ((event == 'opmax' || event == 'opbalance' || event == 'patientResponsibility' || event == 'qualificationName') && this.isfcn) {
      return true
    } else if (event == 'qualificationName' && this.isccn) {
      return false
    } else {
      return false
    }
  }

  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }





  checkchange(id) {
    let date
    if (id != 'Invalid Date')
      date = this.DatePipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.DatePipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = false;
      this.format = true
    } else if (id != '' && id != null && date < curentdate) {
      this.showinvaild = true;
      this.format = false
    } else {
      this.showinvaild = false;
      this.format = false
    }
  }

  submitenrolled(roll) {
    this.showloader = true;
    this.enableenroll = true
    var enroll
    let datevalue = this.DatePipe.transform(this.changeFormatToDate(roll.value.dos), 'yyyy-MM-dd');
    ////console.log(this.ccnchecked)
    if (!roll.value.notesenroll) {
      roll.value.notesenroll = ''
    }
    ////console.log(this.patdata)
    if (this.ccnchecked) {
      this.enrolllist = this.ccnlist
      ////console.log(this.enrolllist)
      enroll = {
        "dos": datevalue,
        "hospitalId": this.enrolllist.hospitalId,
        "hospitalName": this.enrolllist.name,
        "notes": roll.value.notesenroll
      }
      ////console.log(enroll)
    }

    if (!this.ccnchecked) {
      var hospid = this.facility.filter(item => item.name == this.patdata.preferredFacility)
      this.enrolledpat = hospid[0]
      ////console.log(hospid)
      enroll = {
        "dos": datevalue,
        "hospitalId": this.enrolledpat.hospitalId,
        "hospitalName": this.enrolledpat.name,
        "notes": roll.value.notesenroll
      }
      ////console.log(enroll, "enroll")
    }
    ////console.log(enroll, "enroll")
    this.patientservice
      .updateEnroll(this.patdata.bundlePatientId, this.currentUser.item.userAccountId, enroll)
      .subscribe(
        data => {
          if (data) {
            this.showloader = false;
            this.toastr.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
              timeOut: this.timealert
            })
            this.userService.logAudit('enrollPatient', this.patdata.bundlePatientId).subscribe(data => { })
            this.dataGrid.instance.cancelEditData();
            this.modalRef.hide();
            this.enableenroll = false
            this.qualify(this.type)
            this.headerqualificationcount()
          }
          else {
            this.showloader = false;
            this.enableenroll = false
            this.toastr.error("Failed to save")
          }
        }

      );
  }
  /* checkempty(id) {
    ////console.log(id, this.dosMaxDate)
    let today = new Date();
    var d = new Date(id);
    var timeDiff = Math.ceil(d.getTime() - today;
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    ////console.log(diffDays)
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
    } else if (id != '' && id != null) {
      this.showinvaild = false
    }
    if (diffDays > 0) {

      id = '';
      this.dos = '';
      this.toastr.error('Invalid Date', '', {
        timeOut: this.timealert
      })
      return;

    }

  } */
  //this.currentUser.item.userAccountId
  headerqualificationcount() {
    this.patientservice.getcountqual('Default', this.currentUser.item.userAccountId, this.currentUser.item.selectCNUserId).subscribe(
      data => {
        if (data)
          this.currentUser.item.pqtlength = parseInt(data.Count)
      }
    )
  }
  submitmsg(msg) {
    ////console.log(msg.value)
    let comments = {
      "bundlePatientId": this.emp.bundlePatientId,
      "notesComments": msg.value.comment,
      "notesCreatedBy": this.currentUser.item.userAccountId,
      "notesTitle": msg.value.title
    }
    ////console.log(comments)
    this.patientservice
      .savecomment(comments)
      .subscribe(
        data => {
          if (data)
            this.toastr.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'), '', {
              timeOut: this.timealert
            })
          this.userService.logAudit('saveBundleNotes', this.emp.bundlePatientId).subscribe(data => { })
          // this.qualify(this.type);
          this.modalRef.hide();
          this.Noteslist()
          this.ngOnInit()
        }

      );

  }
  ccncheck(e) {
    this.ccnchecked = true
    if (e.target.id == this.ccnstatus) {
      this.visible = true
    } else {
      this.visible = false
    }
    ////console.log(e.target.id)
    ////console.log(e)
    var filterlist = this.facility.filter(item => item.name == e.target.id)
    ////console.log(this.facility)
    ////console.log(filterlist)
    this.ccnlist = filterlist[0]
    ////console.log(this.ccnlist)

  }
  savelist() {
    this.showloader = true;
    this.patientservice
      .updatePreferredFacility(this.currentUser.item.userAccountId, this.ccnlist)
      .subscribe(
        data => {
          if (data) {
            this.showloader = false;
            this.toastr.success(this.userService.translateText('patient_portal.display_messages.saved_successfully'))
            this.userService.logAudit('updatePreferredFacility', 0).subscribe(data => { })
            this.modalRef.hide();
            if (!this.dataGrid.instance.hasEditData())
              this.qualify(this.type);
          }
          else {
            this.showloader = false;
            this.toastr.error("Failed to save")
          }
        }

      );
  }
  changevalue(e) {


  }
  /* ccnchecked()
{
  
  
////console.log(this.ccnstatus)

let index = _.findIndex(this.facility, (o: any): any => {
  return (o.name == this.ccnstatus )
})
if (index == -1) {
  false
} else {
  true
}
} */


  changestage(event) {
    if (event == 1) {
      this.patdisqualifi.qualificationId = 3
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 2) {
      this.patdisqualifi.qualificationId = 18
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 3) {
      this.patdisqualifi.qualificationId = 8
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 4) {
      this.patdisqualifi.qualificationId = 12
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    } else if (event == 6) {
      this.patdisqualifi.qualificationId = 17
      this.patdisqualifi.reasonId = ""
      this.patdisqualifi.other = ""
    }

  }
  reasonstage() {
    this.patientservice
      .getReasonCodeDetailsList()
      .subscribe(
        data => {
          this.reason = data;
        }

      );
  }
  Noteslist() {
    this.patientservice
      .getNotesList(this.emp.bundlePatientId)
      .subscribe(
        data => {
          this.notesmsg = data;
          this.scrollToBottom()
        }

      );
  }
  statuss(value) {
    ////console.log(value)
    this.disresult = value
  }

  disqualifipatient(data) {
    if (this.patdisqualifi && this.patdata) {
      if (!data.value.notes) {
        data.value.notes = ''
      }
      if (!data.value.other) {
        data.value.other = ''
      }
      let disqualifi = {
        bundlePatientId: this.patdata.bundlePatientId,
        loginUserId: this.currentUser.item.userAccountId,
        notes: this.patdisqualifi.notes,
        qualificationId: this.patdisqualifi.qualificationId,
        reasonId: this.patdisqualifi.reasonId,
        reportToCCN: this.disresult,
        other: this.patdisqualifi.other,
        stageId: this.patdisqualifi.stageId
      }
      this.patientservice
        .postdisqualifi(disqualifi)
        .subscribe(
          data => {
            if (data) {
              this.toastr.success(this.userService.translateText('hospital_portal.qualification_lst.patient_disqualified.success'), '', {
                timeOut: this.timealert
              })
              this.userService.logAudit('disQualifyPatient', this.patdata.bundlePatientId).subscribe(data => { })
              this.close()
              this.qualify(this.type)
            }
            else {
              this.toastr.error(this.userService.translateText('patient_portal.display_messages.invalid_data.error'), '', {
                timeOut: this.timealert
              })
            }
          }

        );
    }
  }
  valueChanged(event) {

  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }
  reviewstatus(data) {
    this.patientservice
      .reviewBundlePatientDetailsid(data.bundlePatientId, this.currentUser.item.userAccountId)
      .subscribe(
        data => {
          if (data) {
            this.toastr.success(this.userService.translateText('hospital_portal.patient_dtls.reviewed.success'), '', {
              timeOut: this.timealert
            })
            this.getqualificationcount()
            this.qualify(this.type)
          }
        }

      );
  }

  //Maintain filter data
  FilterVal() {
    this.filterValue = this.dataGrid.filterValue;
    localStorage.setItem("patQualiFilter", btoa(JSON.stringify(this.filterValue)));
  }

  //Clear  Filter data
  clearFilter(event) {
    this.dataGrid.instance.clearFilter();
  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }



  //Clear  Filter data
  getreason(data) {
    return data.bundleDisqualifyReason.toLowerCase() != 'other' ? data.bundleDisqualifyReason : data.otherReasonCode
  }




  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.currentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }
}
